/**
This tooltip module is designed to work only .lendingtree.com domain. For other domain, please disable the same.
*/
<template>
    <span>
        <button
            :id="triggerBtnId"
            :class="tooltipClass"
            :data-target="TooltipId"
            :aria-label="ariaLabel"
            @click="handleClick()">
        </button>

        <!-- use the modal component, pass in the prop -->
        <a11y-modal
            :id="TooltipId"
            :show-loader="ShowLoader">
            <template #h4> {{ GlossaryHeading }} </template>
            <!-- you can use custom content here to overwrite default content -->
            <div
                slot="body"
                v-html="ModalBody"></div>
        </a11y-modal>
    </span>
</template>
<script>
    import a11yModal from '~/helpers/a11y-modal';
    import A11yModal from './a11y-modal.vue';
    import makeHttpRequest from '~/helpers/ajax';
    import wwwUrlEnv from '~/helpers/www-url-env';
    import DebtManagement from '~/constants/debt-management-tooltip';

    export default {
        components: {
            A11yModal,
        },
        props: {
            tooltipLink: {
                default: '',
            },
            tooltipClass: {
                default: 'lt-icons lt4-QuestionOutline calc-question a11y-modal-trigger',
            },
            tooltipText: {
                default: '',
            },
            tooltipId: {
                type: String,
                default: '',
            },
            glossaryHeading: {
                default: '',
            },
            uniqueId: {
                default: '',
            },
            showTooltipLoader: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                ShowLoader: false,
                ShowModal: false,
                ModalBody: '',
                target: '',
                TooltipId: this.tooltipId,
                TooltipLink: this.tooltipLink,
                GlossaryHeading: this.glossaryHeading,
            };
        },
        computed: {
            ariaLabel() {
                if (this.TooltipLink) {
                    return `View information for ${this.TooltipLink.replace(/-/g, ' ').toLowerCase()}`;
                }
                return 'View tooltip';
            },
            triggerBtnId() {
                return `${this.TooltipId}_btn`;
            },
        },
        created() {
            if (window.location.hostname.indexOf('.lendingtree') < 0) {
                this.target = '_blank';
            }
        },
        mounted() {
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
            if (this.uniqueId !== '') {
                this.TooltipId = this.uniqueId;
            } else if (this.TooltipLink) {
                this.TooltipId = this.TooltipLink.replace(/\s+/g, '-').replace(/:/g, '').toLowerCase();
            } else {
                this.TooltipId = `tooltip-${Math.random().toString(36).slice(2)}`;
            }
        },
        methods: {
            handleClick() {
                // Text-only tooltip (no glossary link)
                if (!this.tooltipLink && this.tooltipText) {
                    this.GlossaryHeading = '';
                    this.ModalBody = `<div id="detail" class="detail">${this.tooltipText}</div>`;
                    this.ShowModal = true;
                    return false;
                }
                if (typeof this.tooltipLink !== 'undefined' && this.tooltipLink.indexOf('dma-') >= 0) {
                    this.createModal(DebtManagement.DebtManagementTooltip, this);
                    this.ShowModal = true;
                    return false;
                }
                if (this.target === '') {
                    this.fetchData();
                    this.ShowModal = true;
                    return false;
                }
                if (window.location.hostname.indexOf('.lendingtree') < 0) {
                    const href = `https://www.lendingtree.com/glossary/${this.tooltipLink}`;
                    window.open(href);
                }
                return false;
            },
            fetchData() {
                if (!this.tooltipLink) return false;
                if (this.showTooltipLoader) this.ShowLoader = true;

                this.ModalBody = '';
                const url = `${wwwUrlEnv.getWWWURL()}/wp-json/glossary/v1?slug=${this.tooltipLink}`;
                const glossaryMoreLink = `${wwwUrlEnv.getWWWURL()}/glossary/`;
                const request = {
                    url, storage_key: this.tooltipLink, expTime: 15 * 60 * 1000, headers: { 'x-requested-with': 'XMLHttpRequest' },
                };
                return makeHttpRequest(request).then((response) => {
                    const glossary = JSON.parse(response);
                    if (glossary.term !== 'Not Found') {
                        this.GlossaryHeading = glossary[0].term;
                        this.ModalBody += `<div id="detail" class="detail">${glossary[0].value}</div>`;
                        this.ModalBody += `<div class="content-navigation-ahead"><a href="${glossaryMoreLink}" target="_blank">More Glossary Terms</a></div></div>`;
                    } else {
                        this.ModalBody = '<h3>Glossary Not found.</h3>';
                    }
                    this.ShowLoader = false;
                }, (error) => {
                    this.ShowLoader = false;
                    console.warn(`There is some issue with network call, please try again${error}`);
                });
            },
            createModal(response, self) {
                const glossary = response;
                self.ModalBody = '';
                if (glossary.term !== 'Not Found') {
                    this.GlossaryHeading = glossary[0].term;
                    self.ModalBody += `<div id="detail" class="detail">${glossary[self.tooltipLink].value}</div>`;
                    self.ModalBody += '<div class="content-navigation-ahead"><a href="/glossary/" target="_blank">More Glossary Terms</a></div></div>';
                } else {
                    self.ModalBody = '<h3>Glossary Not found.</h3>';
                }
            },
        },
    };
</script>
<style src="../../../assets/styles/a11yModal.scss" lang="scss"></style>
